import axios from 'axios'
import { merge, curry, cloneDeep } from 'lodash'
import normalize from 'jsonapi-normalizer'

import { asyncReduxFilter } from 'containers/Async/actions'
import {
  copyAndReplaceValuesWithDefaults,
  copyAndReplaceValuesWithValues,
} from './selectors'
import {
  updateTables,
  removeTables,
} from 'containers/Entity/actions'
import {
  LOAD_FORM_DATA,
  CLEAR_FORM_ELEMENTS,
  COPY_FORM_ELEMENTS,
  LOAD_REVISION,
  LOAD_REVISION_SUCCESS,
  LOAD_REVISION_ERROR,
} from './constants'
import {
  getRequest,
} from 'helpers/RequestUtil'
import {
  entitySelector
} from 'containers/Entity/selectors'
import {
  error
} from 'containers/App/Notification/actions'

const copyFormElements = (elements) => ({ type: COPY_FORM_ELEMENTS, elements })
const clearFormElements = () => ({ type: CLEAR_FORM_ELEMENTS })
const loadRevision = (revisionId) => ({ type: LOAD_REVISION, revisionId })
const loadRevisionSuccess = (revisionId, elements) => ({ type: LOAD_REVISION_SUCCESS, revisionId, elements })
const loadRevisionError = (error) => ({ type: LOAD_REVISION_ERROR, error })

const withIncludeAll = (url) => url.concat('?include=all')
const withIncludeValues = (url) => url.concat('?include=values')

// Get all source url links from link attributes
const getAllSourceLinks = ({data}) => {
  return axios.all(data.map(({links: {source: request}}) => request)
    .map(request => {
      let promise = Promise.resolve(null)
      if (request !== undefined)
        promise = getRequest(withIncludeAll(request))
      return promise
    }))
}

// Combine attributes with meta
const addMetaToAttributes = (element) => {
  let meta = element.data.meta
  let attr = element.data.attributes
  let attributes = Object.assign({}, attr, meta)
  element.data.attributes = attributes
  return element
}

// Merge elements and to form elements
// copy elements included and relationships to form elements
const mergeElementToForm = (form, elements) => {
  return form.reduce(
    (result, formElement, index) => {
      let element = elements[index]
      let returnElement = { data: formElement }

      if(element !== null){
        formElement.relationships = cloneDeep(element.data.relationships)
        returnElement.included = cloneDeep(element.included)
      }

      return [...result, returnElement]
    }
  , []
  )
}

// getting all form data in the normalized form which should be used to update
// the entities table
const getNormalizedFormData = (formUrl) => {
  return dispatch => {
    let form = getRequest(formUrl)
    let elements = form.then(getAllSourceLinks)

    return Promise.all([form, elements]).then(
      ([{data: form}, elements]) => mergeElementToForm(form, elements)
    ).then(
      elements => elements.map(addMetaToAttributes)
    ).then(result => result.map(val => normalize(val)))
      .catch(e => dispatch(error('Failed to get form element data.')))
  }
}

const loadDefaultValues = () => {
  return (dispatch, getState) => {
    const entities = entitySelector(getState())
    const elements = copyAndReplaceValuesWithDefaults(entities)
    return dispatch(copyFormElements(elements))
  }
}

const loadSavedValues = () => {
  return (dispatch, getState) => {
    const entities = entitySelector(getState())
    const elements = copyAndReplaceValuesWithValues(entities)
    return dispatch(copyFormElements(elements))
  }
}


const loadFormData = (loadValueFunc) => {
  const loadData = (url) => (
    (dispatch, getState) => {
      return dispatch(getNormalizedFormData(url)).then(
        results => {
          dispatch(clearFormElements())
          dispatch(removeTables('elements'))
          const tables = results.reduce((final, result) => merge(final, result), {})
          dispatch(updateTables(tables))
          return tables
        }).then(() => dispatch(loadValueFunc()))
    }
  )

  return asyncReduxFilter(LOAD_FORM_DATA, loadData)
}

// load form data to store
// after form data is loaded initiate copying of form element entities
// to overviewReducer
const loadDefaultFormData = loadFormData(loadDefaultValues)
const loadSavedFormData = loadFormData(loadSavedValues)

export {
  copyFormElements,
  clearFormElements,
  loadDefaultFormData,
  loadSavedFormData,
  loadRevision,
  loadRevisionSuccess,
  loadRevisionError,
}
